import BaseAPI from "../base";

class WecomAPI extends BaseAPI {
  // 获取成员列表
  async getMemberList(data) {
    return this.post({
      url: `${process.env.VUE_APP_WECOM_APIBASEURL}/wecom/member-list`,
      data: data,
    });
  }

  // 创建推送任务
  async createPushTask(data) {
    return this.post({
      url: `${process.env.VUE_APP_WECOM_APIBASEURL}/wecom/push-task-create`,
      data: data,
    });
  }

  // 获取推送任务列表
  async getPushTaskList(data) {
    return this.post({
      url: `${process.env.VUE_APP_WECOM_APIBASEURL}/wecom/push-task-list`,
      data: data,
    });
  }

  // 获取群组列表
  async getGroupList(data) {
    return this.post({
      url: `${process.env.VUE_APP_WECOM_APIBASEURL}/wecom/group-list`,
      data: data,
    });
  }

  // 创建群组
  async createGroup(data) {
    return this.post({
      url: `${process.env.VUE_APP_WECOM_APIBASEURL}/wecom/group-create`,
      data: data,
    });
  }

  // 删除群组
  async removeGroup(data) {
    return this.post({
      url: `${process.env.VUE_APP_WECOM_APIBASEURL}/wecom/group-remove`,
      data: data,
    });
  }

  // 成员分配群组
  async assignMemberGroup(data) {
    return this.post({
      url: `${process.env.VUE_APP_WECOM_APIBASEURL}/wecom/member-group-assign`,
      data: data,
    });
  }

  // 收藏
  async memberCollect(data) {
    return this.post({
      url: `${process.env.VUE_APP_WECOM_APIBASEURL}/wecom/member-collect`,
      data: data,
    });
  }
}

export default new WecomAPI();
